export default __webpack_public_path__ + "static/media/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.9be96844.woff2";